import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledCounter = styled.div`
    display: flex;
    align-items: center;
    background: var(--cl-gray-400);
    border-radius: 50px;
    color: black;
    float: right;
    font-size: var(--cl-font-size-1);
    font-weight: normal;
    height: var(--cl-space-5);
    justify-content: center;
    padding: 10px;
    width: fit-content;
`;

export const StyledDependentsLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 0.55rem;
    justify-content: center;
`;

export const StyledDependentsTabContainer = styled(Box)`
  &&& {
    height: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px var(--cl-space-4);
    overflow: hidden;
  }
`;

export const StyledDependentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8;
  height: 100%;
  justify-content: flex-start;
  margin-left: var(--cl-space-2);
  margin-right: var(--cl-space-6);
  overflow: scroll;
  padding: var(--cl-space-4) 0px;
  width: 300px;
`;

export const StyledRuleContainer = styled.div`
  border-left: 1px solid var(--cl-gray-400);
  flex-direction: column;
  flex: 1;
  height: 100%;
  justify-content: start;
  overflow: scroll;
  padding: var(--cl-space-4) 0px var(--cl-space-4) var(--cl-space-6);

  /* Rules shown here are not editable so we want to ensure they are not bolded */
  div {
    font-weight: var(--cl-font-weight-normal);
  }
`;
